export const space = {
  11: '2.75rem', // 44px
  36: '9rem', // 144px
};
